import React, { useState, useEffect } from "react";
import ItemsInputField from "../forms/items-input-field";
import ItemsSelectFieldStandalone from "../forms/stand-alone-select-field";
import AddButton from "../buttons/button";
import { useFormikContext } from "formik";
import { useDispatch } from "react-redux";
import { productCreateFromBillingAction } from "../../redux/actions/product-action";
import {
    taxCatListAction,
    uomListAction,
    manufacturesListAction,
    schListAction
} from "../../redux/actions/general-action";
import { uomDropDownAction } from "../../redux/actions/settings-action";
import SelectField from "../forms/select-field";
import successToast from "../helper-components/success-toast";
import errorToast from "../helper-components/error-toast";
import moment from "moment";
import { addBounceReportAction } from "../../redux/actions/report-action";

const CreateProductPanel = ({
    isOpen,
    setIsOpen,
    initialValues,
    setFieldValue,
    setSelectedItem,
    selectedItem,
    qtyRef,
    disabled,
    pack_qty_ref,
    is_auto_batch,
    setBatchModalOpen,
    batchModalOpen,
    setLoading,
    billCreateInputs,
    recalculateTotals,
}) => {
    const { values } = useFormikContext();
    const dispatch = useDispatch();
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [activeTab, setActiveTab] = useState("bounce");


    // Custom styles for consistent form elements
    const formStyles = {
        input: "form-input",
        select: "form-select-wrapper"
    };

    // Dropdown data states
    const [taxList, setTaxList] = useState([]);
    const [uomList, setUomList] = useState([]);
    const [uomData, setUomData] = useState([]);
    const [manufacturesList, setManufacturesList] = useState([]);
    const [schList, setSchList] = useState([]);

    const [errors, setErrors] = useState({});

    // Load dropdown data on component mount
    useEffect(() => {
        dispatch(taxCatListAction(onTaxCatSuccess, onTaxCatError));
        dispatch(uomDropDownAction({}, onFetchUomListSuccess, onFetchUomListError));
        dispatch(manufacturesListAction(onManufacturesSuccess, onManufacturesError));
        dispatch(schListAction(onSchSuccess, onSchError));
    }, []);

    useEffect(() => {
        if (isOpen) {
            // Check if we have pre-loaded data from an existing item
            const existingItemData = values?.tempRowData;

            if (existingItemData?.is_existing_item) {
                // Pre-populate form with existing item data
                setFieldValue("item_name", existingItemData.item_name || "");

                // Store existing item details for API call
                setFieldValue("existing_item_id", existingItemData.item_id);
                setFieldValue("existing_item_code", existingItemData.item_code);

                // Populate UOM list exclusively from alternative UOMs (uom_dropdown)
                let formattedUomData = [];

                if (existingItemData?.uom_dropdown && Array.isArray(existingItemData.uom_dropdown)) {
                    formattedUomData = existingItemData.uom_dropdown.map((item) => ({
                        label: item?.alt_uom,
                        value: existingItemData?.item_uom_id, // As per user: "for this the id is item_uom_id this is outside uom_dropdown"
                    }));
                }

                setUomList(formattedUomData);
            } else {
                // Clear existing item details
                setFieldValue("existing_item_id", "");
                setFieldValue("existing_item_code", "");

                // Restore global UOM list
                const formattedGlobalUomData = uomData.map((item) => ({
                    label: item?.alt_uom || item?.uom_name || item?.label,
                    value: item?.item_id || item?.uom_id || item?.value,
                })) || [];
                setUomList(formattedGlobalUomData);
            }

            // Also reset local state
            setErrors({});
            setIsSubmitting(false);
            setFieldValue("bounce_pack_qty", "");
            setFieldValue("bounce_loose_qty", "");
            setFieldValue("uom", "");
        }
    }, [isOpen, setFieldValue, values?.tempRowData]);

    // API success/error handlers
    const onTaxCatSuccess = (data) => {
        const formattedData = data?.data?.map((item) => ({
            label: item?.code,
            value: item?.id,
        })) || [];
        setTaxList(formattedData);
    };

    const onTaxCatError = (data) => {
        setTaxList([]);
    };

    const onFetchUomListSuccess = (data) => {
        console.log("data", data);

        // Handle the new uomDropDown endpoint data structure
        const uomList = data?.data || [];
        setUomData(uomList);

        console.log("uomList", uomList);

        const formattedUomData = uomList.map((item) => ({
            label: item?.alt_uom || item?.uom_name || item?.label,
            value: item?.item_id || item?.uom_id || item?.value,
        })) || [];

        console.log("formattedUomData", formattedUomData);

        setUomList(formattedUomData);
    };

    const onFetchUomListError = (data) => {
        console.log("data", data);
        setUomData([]);
        setUomList([]);
    };

    const onManufacturesSuccess = (data) => {
        // Handle case where data is null (no manufacturers found)
        if (data?.data && Array.isArray(data.data)) {
            setManufacturesList(
                data.data.map((item) => ({
                    label: item?.name,
                    value: item?.id,
                }))
            );
        } else {
            setManufacturesList([]);
        }
    };

    const onManufacturesError = (data) => {
        setManufacturesList([]);
    };

    const onSchSuccess = (data) => {
        setSchList(
            data?.data?.scheduleList?.map((item) => ({
                label: item?.schedule,
                value: item?.schedule,
            })) || []
        );
    };

    const onSchError = (data) => {
        setSchList([]);
    };

    const validateForm = () => {
        const newErrors = {};

        if (!values.item_name?.trim()) {
            newErrors.item_name = "Item Name is required";
        }
        // if (!values.pack_size?.trim()) {
        //     newErrors.pack_size = "Pack Size is required";
        // }
        if (!values.batch_number?.trim()) {
            newErrors.batch_number = "Batch Number is required";
        }
        // if (!values.pack_qty?.trim()) {
        //     newErrors.pack_qty = "Pack Quantity is required";
        // }
        if (!values.loose_qty?.trim()) {
            newErrors.loose_qty = "Loose Quantity is required";
        }
        if (!values.uom) {
            newErrors.uom = "UOM is required";
        }
        if (!values.tax_category) {
            newErrors.tax_category = "Tax Category is required";
        }
        if (!values.hsn?.trim()) {
            newErrors.hsn = "HSN is required";
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSave = () => {
        if (!validateForm()) {
            console.log("errors", errors);
            return;
        }

        // Check if expiration date is provided and not expired
        if (values.exp_date) {
            const expirationDate = moment(values.exp_date);
            const currentDate = moment().startOf('day');

            if (expirationDate.isBefore(currentDate)) {
                errorToast("Cannot save products with expired dates. Please select a future expiration date.");
                return;
            }
        }

        setIsSubmitting(true);

        // Check if we're dealing with an existing item or creating a new one
        const isExistingItem = values.existing_item_id && values.existing_item_code;

        // Create API payload based on the required format
        const apiPayload = {
            item_name: values.item_name,
            item_generic_name: values.item_name,
            item_uom_id: values.uom, // UOM ID
            item_tax_category: values.tax_category, // Tax Category ID
            item_unit_price: parseFloat(values.mrp) || 0,
            item_batch_number: values.batch_number,
            item_quantity: parseFloat(values.pack_qty || 0) + parseFloat(values.loose_qty || 0),
            item_discount_percentage: parseFloat(values.discount_percentage) || 0,
            item_total_amount: parseFloat(values.mrp) * (parseFloat(values.pack_qty || 0) + parseFloat(values.loose_qty || 0)),
            item_pack_qty: values.pack_qty || 0,
            item_loose_qty: values.loose_qty || 0,
            item_exp_date: values.exp_date || "",
            item_uom: "", // This should be empty as per API response
            // Additional fields from the main product form
            item_hsn: values.hsn,
            item_manufacturer: values.manufacturer || "",
            item_schedule: values.schedule || "",
            item_pack_size: parseFloat(values.pack_size) || 0
        };

        // If it's an existing item, add the item_id and item_code
        if (isExistingItem) {
            apiPayload.item_id = values.existing_item_id;
            apiPayload.item_code = values.existing_item_code;
        }

        const onSuccess = (response) => {
            setIsSubmitting(false);
            const successMessage = isExistingItem
                ? (response?.message || "Inventory added successfully")
                : (response?.message || "Product created successfully");
            successToast(successMessage);

            // Get values from API response instead of form values
            const taxPercentage = parseFloat(response?.data?.item_total_tax_percentage) || 0;
            const packQty = parseFloat(response?.data?.item_pack_qty) || 0;
            const looseQty = parseFloat(response?.data?.item_loose_qty) || 0;
            const totalQuantity = packQty + looseQty;
            const unitPrice = parseFloat(response?.data?.item_unit_price) || 0;
            const discountPercentage = parseFloat(response?.data?.item_discount_percentage) || 0;

            // Calculate discount amount
            const totalAmountBeforeDiscount = unitPrice * totalQuantity;
            const discountAmount = (totalAmountBeforeDiscount * discountPercentage) / 100;
            const amountAfterDiscount = totalAmountBeforeDiscount - discountAmount;

            // Calculate tax amount using tax percentage from response
            const taxAmount = (amountAfterDiscount * taxPercentage) / 100;

            // Calculate final amounts
            const finalAmount = amountAfterDiscount + taxAmount;
            const finalPricePerUnit = finalAmount / totalQuantity;

            // Create product object for local billing table using API response data
            const newProduct = {
                item_code: response?.data?.item_code || values.existing_item_code || `NEW_${Date.now()}`,
                item_name: response?.data?.item_name || values.item_name,
                item_generic_name: response?.data?.item_generic_name || values.item_name,
                total_sellable_quantity: totalQuantity,
                quantity: totalQuantity,
                item_pack_qty: packQty,
                item_loose_qty: looseQty,
                item_free_quantity: parseFloat(values.sch_free_qty) || 0,
                item_uom: uomList.find(uom => uom.value === values.uom)?.label || values.uom, // Get UOM name instead of ID
                item_batch_number: response?.data?.item_batch_number || values.batch_number,
                item_exp_date: response?.data?.item_exp_date || (values.exp_date ? moment(values.exp_date).format("YYYY-MM-DD") : ""),
                item_rack_location: "",
                item_manufacturer_name: "",
                item_schedule: response?.data?.item_schedule || values.schedule || "",
                item_hsn: response?.data?.item_hsn || values.hsn,
                item_unit_price: unitPrice,
                item_price_wiithout_tax: amountAfterDiscount,
                item_discount_amount: discountAmount,
                item_discount_percentage: discountPercentage,
                item_tax_amount: taxAmount,
                item_gst: taxPercentage,
                item_final_price: finalPricePerUnit,
                item_margin_percentage: 0,
                item_total_amount: finalAmount,
                item_id: response?.data?.item_id || values.existing_item_id || `temp_${Date.now()}`,
                to_bin_id: "",
                instock: true,
                item_sgst: taxAmount / 2,
                item_cgst: taxAmount / 2,
                item_igst: 0,
                item_manufacturer_id: response?.data?.item_manufacturer || values.manufacturer || "",
                item_pack_size: parseFloat(response?.data?.item_pack_size) || parseFloat(values.pack_size) || 0,
                item_refill_days: values.refill_days || "",
                item_shortage_qty: values.shortage_qty || "",
                max_pack_qty: packQty,
                max_loose_qty: looseQty,
                item_total_tax_percentage: taxPercentage,
                minDiscountPercentage: 0,
                maxDiscountPercentage: 100,
                is_predefined_dis: discountPercentage > 0,
                is_store_added_item: true,
            };

            // Add to the billing items table
            const updatedData = [...(values?.data || []), newProduct];
            setFieldValue("data", updatedData);

            // Call recalculateTotals to update the footer totals
            if (recalculateTotals) {
                recalculateTotals();
            }

            // Set as selected item
            setSelectedItem({
                itemid: newProduct.item_id,
                item_name: newProduct.item_name,
                index: updatedData.length - 1,
            });

            // Set temp row data
            setFieldValue("tempRowData", newProduct);

            // Close the panel
            setIsOpen(false);

            // Focus on quantity field
            setTimeout(() => {
                if (is_auto_batch) {
                    qtyRef?.current?.focus();
                } else {
                    pack_qty_ref?.current?.focus();
                }
            }, 300);
        };

        const onError = (error) => {
            setIsSubmitting(false);
            const errorMessage = isExistingItem
                ? (error?.data?.message || "Failed to add inventory")
                : (error?.data?.message || "Failed to create product");
            errorToast(errorMessage);
        };

        // Dispatch the API call
        dispatch(productCreateFromBillingAction(apiPayload, onSuccess, onError));
    };

    const handleBounceSave = () => {
        const newErrors = {};
        if (!values.uom) newErrors.uom = "UOM is required";

        // Check if at least one quantity is entered
        const packQty = parseFloat(values.bounce_pack_qty || 0);
        const looseQty = parseFloat(values.bounce_loose_qty || 0);

        if (packQty === 0 && looseQty === 0) {
            newErrors.bounce_qty = "Please enter either Pack Qty or Loose Qty";
        }

        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            return;
        }

        setIsSubmitting(true);

        const payload = {
            date: moment().format("YYYY-MM-DD HH:mm:ss"),
            cmr_id: values.cmr_id || "",
            cmr_code: values.cmr_code || values.phone?.value || "",
            cmr_name: values.cmr_first_name || values.phone?.label?.split(',')[0] || "",
            item_id: values.tempRowData?.item_id || "",
            item_code: values.tempRowData?.item_code || "",
            item_name: values.tempRowData?.item_name || values.item_name || "",
            uom: values.uom,
            bounce_pack: packQty,
            bounce_loose: looseQty,
        };

        dispatch(addBounceReportAction(payload,
            (res) => {
                setIsSubmitting(false);
                successToast("Added to Bounce Report successfully");
                handleCancel();
            },
            (err) => {
                setIsSubmitting(false);
                errorToast(err?.message || "Failed to add to Bounce Report");
            }
        ));
    };

    const handleCancel = () => {
        // Clear existing item details
        setFieldValue("existing_item_id", "");
        setFieldValue("existing_item_code", "");

        // Also reset local state
        setErrors({});
        setIsOpen(false);
    };

    if (!isOpen) return null;

    return (
        <>
            {/* Custom styles for consistent form elements */}
            <style jsx>{`
                .form-input {
                    height: 2.5rem;
                    border: 1px solid #d1d5db;
                    border-radius: 0.375rem;
                    padding: 0.5rem 0.75rem;
                    width: 100%;
                    font-size: 0.875rem;
                    line-height: 1.25rem;
                    transition: all 0.2s;
                }
                .form-input:focus {
                    outline: none;
                    border-color: transparent;
                    box-shadow: 0 0 0 2px #3b82f6;
                }
                .form-select-wrapper {
                    height: 2.5rem;
                    border: 1px solid #d1d5db;
                    border-radius: 0.375rem;
                    transition: all 0.2s;
                    overflow: hidden;
                }
                .form-select-wrapper:focus-within {
                    border-color: transparent;
                    box-shadow: 0 0 0 2px #3b82f6;
                }
                .form-select-wrapper > div {
                    height: 100% !important;
                    border: none !important;
                    box-shadow: none !important;
                }
                .form-select-wrapper input {
                    height: 100% !important;
                    border: none !important;
                    box-shadow: none !important;
                    outline: none !important;
                }
                .form-select-wrapper .css-13cymwt-control,
                .form-select-wrapper .css-t3ipsp-control {
                    border: none !important;
                    box-shadow: none !important;
                    min-height: 100% !important;
                }
                .form-select-wrapper .css-1fdsijx-ValueContainer {
                    padding: 0.5rem 0.75rem !important;
                }
                .form-select-wrapper .css-1dimb5e-singleValue {
                    margin: 0 !important;
                }
                .form-select-wrapper * {
                    border: none !important;
                    box-shadow: none !important;
                }
                .form-select-wrapper .css-1u9desv-input {
                    margin: 0 !important;
                    padding: 0 !important;
                }
                .form-select-wrapper .css-1jqq78o-placeholder {
                    margin: 0 !important;
                    padding: 0 !important;
                }
                .tab-button {
                    padding: 0.75rem 1rem;
                    font-size: 0.875rem;
                    font-weight: 500;
                    border-bottom: 2px solid transparent;
                    color: #6B7280;
                    transition: all 0.2s;
                }
                .tab-button.active {
                    color: #3B82F6;
                    border-bottom-color: #3B82F6;
                }
                .tab-button:hover:not(.active) {
                    color: #374151;
                    border-bottom-color: #D1D5DB;
                }
            `}</style>

            {/* Backdrop */}
            <div
                className="fixed inset-0 bg-[#00000060] z-40"
                onClick={handleCancel}
            />

            {/* Side Panel */}
            <div
                className={`fixed right-0 top-0 h-full max-w-2xl bg-white shadow-2xl transform transition-transform duration-300 ease-in-out z-50 ${isOpen ? 'translate-x-0' : 'translate-x-full'
                    } flex flex-col`}
                style={{
                    '--primary': '#3B82F6',
                    '--primary-hover': '#2563EB',
                    '--danger': '#EF4444',
                    '--danger-hover': '#DC2626',
                }}
            >
                {/* Header */}
                <div className="flex flex-col border-b border-gray-200 bg-white">
                    <div className="flex items-center justify-between p-6 pb-0">
                        <div>
                            <h2 className="text-xl font-semibold text-gray-900">
                                {values?.existing_item_id ? "Add Inventory" : "Add New Product"}
                            </h2>
                            <p className="text-sm text-gray-600 mt-1">
                                {values?.existing_item_id
                                    ? `Add inventory for existing product: ${values.tempRowData?.item_name || "Product"}`
                                    : "Enter the below details to add new product"
                                }
                            </p>
                        </div>
                        <button
                            onClick={handleCancel}
                            className="text-gray-400 hover:text-gray-600 transition-colors"
                        >
                            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                            </svg>
                        </button>
                    </div>

                    {/* Tabs */}
                    <div className="flex px-6 mt-4 gap-6">
                        <button
                            className={`tab-button ${activeTab === 'bounce' ? 'active' : ''}`}
                            onClick={() => setActiveTab('bounce')}
                        >
                            Add to Bounce Report
                        </button>
                        <button
                            className={`tab-button ${activeTab === 'inventory' ? 'active' : ''}`}
                            onClick={() => setActiveTab('inventory')}
                        >
                            Add Inventory
                        </button>
                    </div>
                </div>

                {/* Form Content */}
                <div className="p-6 flex-1 overflow-y-auto mb-20">
                    {activeTab === 'inventory' ? (
                        <>
                            {/* Hidden fields for existing item details */}
                            <input type="hidden" name="existing_item_id" value={values.existing_item_id || ""} />
                            <input type="hidden" name="existing_item_code" value={values.existing_item_code || ""} />

                            <div className="space-y-4">
                                {/* Item Name - Full Width */}
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-1">
                                        Item Name <span className="text-F51D00">*</span>
                                    </label>
                                    <ItemsInputField
                                        name="item_name"
                                        allowAll={true}
                                        placeholder="Placeholder"
                                        error={errors.item_name}
                                        className={formStyles.input}
                                    />
                                    {errors.item_name && (
                                        <p className="text-F51D00 text-xs mt-1">{errors.item_name}</p>
                                    )}
                                </div>

                                {/* UOM & Loose Qty - Two Column */}
                                <div className="grid grid-cols-2 gap-4">
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-1">
                                            UOM <span className="text-F51D00">*</span>
                                        </label>
                                        <div className={formStyles.select}>
                                            <ItemsSelectFieldStandalone
                                                name="uom"
                                                placeholder="Select UOM"
                                                options={uomList || []}
                                                isSearchable={true}
                                                value={values.uom}
                                                onChange={(selectedOption) => {
                                                    setFieldValue("uom", selectedOption?.value || "");
                                                }}
                                            />
                                        </div>
                                        {errors.uom && (
                                            <p className="text-F51D00 text-xs mt-1">{errors.uom}</p>
                                        )}
                                    </div>
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-1">
                                            Loose Qty <span className="text-F51D00">*</span>
                                        </label>
                                        <ItemsInputField
                                            name="loose_qty"
                                            placeholder="Placeholder"
                                            error={errors.loose_qty}
                                            className={formStyles.input}
                                        />
                                        {errors.loose_qty && (
                                            <p className="text-F51D00 text-xs mt-1">{errors.loose_qty}</p>
                                        )}
                                    </div>
                                </div>

                                {/* Batch No. & Exp Date - Two Column */}
                                <div className="grid grid-cols-2 gap-4">
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-1">
                                            Batch No. <span className="text-F51D00">*</span>
                                        </label>
                                        <ItemsInputField
                                            name="batch_number"
                                            placeholder="Placeholder"
                                            error={errors.batch_number}
                                            className={formStyles.input}
                                        />
                                        {errors.batch_number && (
                                            <p className="text-F51D00 text-xs mt-1">{errors.batch_number}</p>
                                        )}
                                    </div>
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-1">
                                            Exp Date
                                        </label>
                                        <div className="relative">
                                            <ItemsInputField
                                                type="date"
                                                name="exp_date"
                                                placeholder="Pick a date"
                                                className={formStyles.input}
                                            />
                                            <div className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
                                                <svg className="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                                                </svg>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* HSN & MRP - Two Column */}
                                <div className="grid grid-cols-2 gap-4">
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-1">
                                            HSN <span className="text-F51D00">*</span>
                                        </label>
                                        <ItemsInputField
                                            name="hsn"
                                            placeholder="Placeholder"
                                            error={errors.hsn}
                                            className={formStyles.input}
                                        />
                                        {errors.hsn && (
                                            <p className="text-F51D00 text-xs mt-1">{errors.hsn}</p>
                                        )}
                                    </div>
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-1">
                                            MRP
                                        </label>
                                        <ItemsInputField
                                            name="mrp"
                                            placeholder="Placeholder"
                                            className={formStyles.input}
                                        />
                                    </div>
                                </div>

                                {/* Manufacturer & Schedule - Two Column */}
                                <div className="grid grid-cols-2 gap-4">
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-1">
                                            Manufacturer
                                        </label>
                                        <div className={formStyles.select}>
                                            <ItemsSelectFieldStandalone
                                                name="manufacturer"
                                                placeholder="Select Manufacturer"
                                                options={manufacturesList || []}
                                                isSearchable={true}
                                                value={values.manufacturer}
                                                onChange={(selectedOption) => {
                                                    setFieldValue("manufacturer", selectedOption?.value || "");
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-1">
                                            Schedule
                                        </label>
                                        <div className={formStyles.select}>
                                            <ItemsSelectFieldStandalone
                                                name="schedule"
                                                placeholder="Select Schedule"
                                                options={schList || []}
                                                isSearchable={true}
                                                value={values.schedule}
                                                onChange={(selectedOption) => {
                                                    setFieldValue("schedule", selectedOption?.value || "");
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>

                                {/* Discount% & Tax% - Two Column */}
                                <div className="grid grid-cols-2 gap-4">
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-1">
                                            Discount%
                                        </label>
                                        <ItemsInputField
                                            name="discount_percentage"
                                            placeholder="Placeholder"
                                            className={formStyles.input}
                                        />
                                    </div>
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-1">
                                            Tax Category <span className="text-F51D00">*</span>
                                        </label>
                                        <div className={formStyles.select}>
                                            <ItemsSelectFieldStandalone
                                                name="tax_category"
                                                placeholder="Select Tax Category"
                                                options={taxList || []}
                                                isSearchable={true}
                                                value={values.tax_category}
                                                onChange={(selectedOption) => {
                                                    setFieldValue("tax_category", selectedOption?.value || "");
                                                }}
                                            />
                                        </div>
                                        {errors.tax_category && (
                                            <p className="text-F51D00 text-xs mt-1">{errors.tax_category}</p>
                                        )}
                                    </div>
                                </div>

                                {/* Refill Days & Shortage Qty - Two Column */}
                                <div className="grid grid-cols-2 gap-4">
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-1">
                                            Refill Days
                                        </label>
                                        <ItemsInputField
                                            name="refill_days"
                                            placeholder="Placeholder"
                                            className={formStyles.input}
                                        />
                                    </div>
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-1">
                                            Shortage Qty
                                        </label>
                                        <ItemsInputField
                                            name="shortage_qty"
                                            placeholder="Placeholder"
                                            className={formStyles.input}
                                        />
                                    </div>
                                </div>
                            </div>
                        </>
                    ) : (
                        <div className="space-y-4">
                            {/* Bounce Report Form */}
                            <div className="grid grid-cols-2 gap-4">
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-1">
                                        Bounce Date
                                    </label>
                                    <input
                                        type="text"
                                        disabled
                                        value={moment().format("DD/MM/YYYY hh:mm A")}
                                        className={`${formStyles.input} bg-gray-50`}
                                    />
                                </div>
                                <div>
                                    {/* Empty for spacing or second field */}
                                </div>
                            </div>

                            <div className="grid grid-cols-2 gap-4">
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-1">
                                        Customer Code
                                    </label>
                                    <input
                                        type="text"
                                        disabled
                                        value={values.cmr_code || values.phone?.value || "-"}
                                        className={`${formStyles.input} bg-gray-50`}
                                    />
                                </div>
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-1">
                                        Customer Name
                                    </label>
                                    <input
                                        type="text"
                                        disabled
                                        value={values.cmr_first_name || values.phone?.label?.split(',')[0] || "-"}
                                        className={`${formStyles.input} bg-gray-50`}
                                    />
                                </div>
                            </div>

                            <div className="grid grid-cols-2 gap-4">
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-1">
                                        Item Code
                                    </label>
                                    <input
                                        type="text"
                                        disabled
                                        value={values.tempRowData?.item_code || "-"}
                                        className={`${formStyles.input} bg-gray-50`}
                                    />
                                </div>
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-1">
                                        Item Name
                                    </label>
                                    <input
                                        type="text"
                                        disabled
                                        value={values.tempRowData?.item_name || values.item_name || "-"}
                                        className={`${formStyles.input} bg-gray-50`}
                                    />
                                </div>
                            </div>

                            <div className="grid grid-cols-3 gap-4">
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-1">
                                        UOM <span className="text-F51D00">*</span>
                                    </label>
                                    <div className={formStyles.select}>
                                        <ItemsSelectFieldStandalone
                                            name="uom"
                                            placeholder="Select UOM"
                                            options={uomList || []}
                                            isSearchable={true}
                                            value={values.uom}
                                            onChange={(selectedOption) => {
                                                setFieldValue("uom", selectedOption?.value || "");
                                            }}
                                        />
                                    </div>
                                    {errors.uom && (
                                        <p className="text-F51D00 text-xs mt-1">{errors.uom}</p>
                                    )}
                                </div>
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-1">
                                        Bounced Pack Qty
                                    </label>
                                    <ItemsInputField
                                        name="bounce_pack_qty"
                                        placeholder="0"
                                        type="number"
                                        className={formStyles.input}
                                    />
                                </div>
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-1">
                                        Bounced Loose Qty
                                    </label>
                                    <ItemsInputField
                                        name="bounce_loose_qty"
                                        placeholder="0"
                                        type="number"
                                        className={formStyles.input}
                                    />
                                </div>
                            </div>
                            {(errors.bounce_qty) && (
                                <p className="text-F51D00 text-xs">{errors.bounce_qty}</p>
                            )}
                        </div>
                    )}
                </div>

                {/* Footer Actions */}
                <div className="absolute bottom-0 left-0 right-0 p-6 border-t border-gray-200 bg-white">
                    <div className="flex gap-3">
                        <button
                            type="button"
                            onClick={handleCancel}
                            className="flex-1 px-4 py-2 bg-red-500 text-white rounded hover:bg-red-600 transition-colors"
                            style={{
                                backgroundColor: 'var(--danger)',
                            }}
                            onMouseEnter={(e) => e.target.style.backgroundColor = 'var(--danger-hover)'}
                            onMouseLeave={(e) => e.target.style.backgroundColor = 'var(--danger)'}
                        >
                            Cancel
                        </button>
                        <button
                            type="button"
                            onClick={activeTab === 'inventory' ? handleSave : handleBounceSave}
                            disabled={isSubmitting}
                            className="flex-1 px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                            style={{
                                backgroundColor: isSubmitting ? '#9CA3AF' : 'var(--primary)',
                            }}
                            onMouseEnter={(e) => !isSubmitting && (e.target.style.backgroundColor = 'var(--primary-hover)')}
                            onMouseLeave={(e) => !isSubmitting && (e.target.style.backgroundColor = 'var(--primary)')}
                        >
                            {isSubmitting ? (
                                <div className="flex items-center justify-center gap-2">
                                    <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                                    {activeTab === 'inventory'
                                        ? (values?.existing_item_id ? "Adding..." : "Creating...")
                                        : "Adding..."
                                    }
                                </div>
                            ) : (
                                activeTab === 'inventory'
                                    ? (values?.existing_item_id ? 'Add' : 'Save')
                                    : 'Add'
                            )}
                        </button>
                    </div>
                </div>
            </div>
        </>
    );
};

export default CreateProductPanel; 